import { configureStore } from '@reduxjs/toolkit';

import { resourcesApi } from '@helsenorge/core-framework/resources';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';

import behandlingsvalgApi from './behandlingsvalgApi';
import rootReducer from './reducer';
import samvalgsverktoyApi from './samvalgsverktoyApi';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      // Felles
      .concat(tjenesteTeksterApi.middleware)
      .concat(resourcesApi.middleware)
      .concat(additionalPageContentApi.middleware)
      // Spesielt for Samvalg
      .concat(samvalgsverktoyApi.middleware)
      .concat(behandlingsvalgApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
